// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"index_logoContainer_3qvcH","block":"index_block_26PEs","inner":"index_inner_7rnbY","form":"index_form_12F_5"};